module.exports = __webpack_public_path__ + "img/map-option-jicha.fbe900f6.png";